module.exports = __webpack_public_path__ + "static/media/Formular-Regular.57ac02ec.woff";